const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));

export const getPostcodes = () => {
  const part1 = range(1000, 2249, 1);
  const part2 = range(2760, 2770, 1);

  const result = part1.concat(part2);
  return result;
}

export const ranges = {1: [1000, 2249], 2: [2760, 2770]}